import React from "react";
import contactIcon from "assets/icons/customer-care.png";
import { Popover } from "@mui/material";
import { useState } from "react";
import { useRef } from "react";

const Contact = () => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  return (
    <>
      <div
        ref={ref}
        onClick={() => setOpen((cur) => !cur)}
        className="cursor-pointer"
      >
        <img
          src={contactIcon}
          alt="contact"
          title="Contact Us"
          width={35}
          height={35}
        />
      </div>

      <Popover
        id="contact-us-home"
        open={open}
        anchorEl={ref.current}
        onClose={() => setOpen(false)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div className="p-2 text-xs lg:text-sm bg-red text-white opacity-90">
          <a href="tel:9051557423">Adrija: +91 90515 57423</a>
          <br />
          <a href="tel:8910221851">Soumyajit: +91 89102 21851</a>
        </div>
      </Popover>
    </>
  );
};

export default Contact;
